/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable import/prefer-default-export */

import React from 'react'

export function CloseIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M19.7802 17.719C19.8499 17.7887 19.9052 17.8714 19.9429 17.9625C19.9806 18.0535 20 18.1511 20 18.2496C20 18.3482 19.9806 18.4457 19.9429 18.5368C19.9052 18.6278 19.8499 18.7105 19.7802 18.7802C19.7105 18.8499 19.6278 18.9052 19.5368 18.9429C19.4457 18.9806 19.3482 19 19.2496 19C19.1511 19 19.0535 18.9806 18.9625 18.9429C18.8714 18.9052 18.7887 18.8499 18.719 18.7802L12.5 12.5603L6.28097 18.7802C6.14025 18.9209 5.94939 19 5.75038 19C5.55136 19 5.3605 18.9209 5.21978 18.7802C5.07906 18.6395 5 18.4486 5 18.2496C5 18.0506 5.07906 17.8598 5.21978 17.719L11.4397 11.5L5.21978 5.28097C5.07906 5.14025 5 4.94939 5 4.75038C5 4.55136 5.07906 4.3605 5.21978 4.21978C5.3605 4.07906 5.55136 4 5.75038 4C5.94939 4 6.14025 4.07906 6.28097 4.21978L12.5 10.4397L18.719 4.21978C18.8598 4.07906 19.0506 4 19.2496 4C19.4486 4 19.6395 4.07906 19.7802 4.21978C19.9209 4.3605 20 4.55136 20 4.75038C20 4.94939 19.9209 5.14025 19.7802 5.28097L13.5603 11.5L19.7802 17.719Z"
        fill="#ECECEC"
      />
    </svg>
  )
}
